<template>
  <div class="carrers">
    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-200 mb-8">
      <h1 class="text-4xl">
        careers
      </h1>
    </div>
    <div class="flex flex-col lg:flex-row mb-24" v-if="ready">
<!--      <div class="w-full lg:w-1/4 sm:px-3 mb-3 lg:mb-0">-->
<!--        <div class="title-select">-->
<!--          <h3 class="bg-themeRed p-4 text-white	 uppercase text-3xl">search options</h3>-->
<!--        </div>-->
<!--        <div class="box-select flex flex-wrap p-4 bg-grayLight2">-->
<!--          <div class="flex flex-col w-full sm:w-1/2 lg:w-full sm:p-2 lg:p-0">-->
<!--            <label>-->
<!--              Type-->
<!--            </label>-->
<!--            <div class="flex justify-center">-->
<!--              <div class="mb-3 w-full">-->
<!--                <select class="form-select-->
<!--                                block-->
<!--                                w-full-->
<!--                                px-3-->
<!--                                py-1.5-->
<!--                                text-base-->
<!--                                font-normal-->
<!--                                text-gray-700-->
<!--                                bg-white bg-clip-padding bg-no-repeat-->
<!--                                border border-solid border-gray-300-->
<!--                                rounded-->
<!--                                transition-->
<!--                                ease-in-out-->
<!--                                m-0-->
<!--                                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example"-->
<!--                        v-model="type"-->
<!--                >-->
<!--                  <option v-for="type in types" :value="type.id">{{type.name}}</option>-->
<!--                </select>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="flex flex-col w-full sm:w-1/2 lg:w-full sm:p-2 lg:p-0">-->
<!--            <label>-->
<!--              State-->
<!--            </label>-->
<!--            <div class="flex justify-center">-->
<!--              <div class="mb-3 w-full">-->
<!--                <select class="form-select-->
<!--                block-->
<!--                w-full-->
<!--                px-3-->
<!--                py-1.5-->
<!--                text-base-->
<!--                font-normal-->
<!--                text-gray-700-->
<!--                bg-white bg-clip-padding bg-no-repeat-->
<!--                border border-solid border-gray-300-->
<!--                rounded-->
<!--                transition-->
<!--                ease-in-out-->
<!--                m-0-->
<!--                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example"-->
<!--                v-model="state"-->
<!--                >-->
<!--                  <option v-for="state in states" :value="state.id">{{state.name}}</option>-->
<!--                </select>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="flex flex-col w-full sm:w-1/2 lg:w-full sm:p-2 lg:p-0">-->
<!--            <label>-->
<!--              City-->
<!--            </label>-->
<!--            <div class="flex justify-center">-->
<!--              <div class="mb-3 w-full">-->
<!--                <select class="form-select-->
<!--                block-->
<!--                w-full-->
<!--                px-3-->
<!--                py-1.5-->
<!--                text-base-->
<!--                font-normal-->
<!--                text-gray-700-->
<!--                bg-white bg-clip-padding bg-no-repeat-->
<!--                border border-solid border-gray-300-->
<!--                rounded-->
<!--                transition-->
<!--                ease-in-out-->
<!--                m-0-->
<!--                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example"-->
<!--                v-model="city">-->
<!--                  <option v-for="city in cities" :value="city.id">{{city.name}}</option>-->
<!--                </select>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="flex flex-col w-full sm:w-1/2 lg:w-full sm:p-2 lg:p-0">-->
<!--            <label>-->
<!--              Added-->
<!--            </label>-->
<!--            <div class="flex justify-center">-->
<!--              <div class="mb-3 w-full">-->
<!--                <select class="form-select-->
<!--                block-->
<!--                w-full-->
<!--                px-3-->
<!--                py-1.5-->
<!--                text-base-->
<!--                font-normal-->
<!--                text-gray-700-->
<!--                bg-white bg-clip-padding bg-no-repeat-->
<!--                border border-solid border-gray-300-->
<!--                rounded-->
<!--                transition-->
<!--                ease-in-out-->
<!--                m-0-->
<!--                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example"-->
<!--                v-model="date">-->
<!--                  <option v-for="date in dates" :value="date.id">{{date.name}}</option>-->
<!--                </select>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="flex space-x-2 justify-center w-full">-->
<!--            <button type="button" class="inline-block px-6 py-2.5 bg-gray-800 text-white font-medium text-xs leading-tight-->
<!--            uppercase rounded shadow-md hover:bg-gray-900 hover:shadow-lg focus:bg-gray-900 focus:shadow-lg w-full-->
<!--            focus:outline-none focus:ring-0 active:bg-gray-900 active:shadow-lg transition duration-150 uppercase text-tiny-->
<!--            ease-in-out" @click="resetFilter()">-->
<!--              reset-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="w-full sm:px-3 max-w-[1200px] mx-auto">
        <div class="box-description mb-7">
          <p class="text-tiny mb-1">
            Do you have a dream of putting your talents to work in the horse business?
          </p>
          <p class="mb-2">National Horseman is always looking for
            motivated, hard-working people to join our team. Careers at The National Horseman range from writers and editors
            to sales representatives, graphic designers and more.
          </p>
          <p class="font-bold text-2xl">
            Turn your passion for horses into a career by contacting us
            at (480) 922-5202 or email today.
          </p>
        </div>
        <div class="box-table">
          <h3 class="uppercase text-4xl border-b-2 border-black ">CURRENT OPPORTUNITIES</h3>


          <div class="flex flex-col py-6 border-b border-black"  v-for="career in careers">
            <div class="flex w-full flex-wrap">
              <div class="basis-2/12 md:basis-1/12">
<!--                <img src="/icons/editor-icon.svg" alt="editor icon" width="80" height="60">-->
<!--                <img src="/logo_e.svg" alt="icon" width="80" height="60">-->
                <nuxt-img v-if="career.image" :src="siteURL + '/storage/images/companies/' + career.image" :alt="career.title" width="80" height="60"/>
              </div>
              <div class="basis-7/12 md:basis-6/12 px-2 md:pl-4 flex items-center">
                <div class="flex flex-col ">
                  <p class="text-base"> {{ career.created_at }}</p>
                  <p class="text-xl md:text-3xl.5 font-bold">{{ career.title }}</p>
                </div>
              </div>
              <div class="basis-3/2 md:basis-3/12 flex items-center">
                <img src="/icons/location-icon.svg" class="mr-2" alt="location" width="15" height="15">
                {{career.city}}
              </div>
              <div class="w-full mt-4 md:my-0 md:basis-2/12 flex items-center justify-center">
                <NuxtLink :to="'/employment/title/'+career.id" class="text-white bg-black p-2 rounded">
                    Show more
                  </NuxtLink>
              </div>
            </div>
          </div>
<!--          <table class="table-auto border  border-separate w-full">-->
<!--            <thead>-->
<!--            <tr class="bg-themeRed text-white ">-->
<!--              <th class="uppercase text-sm p-1 md:p-3">title</th>-->
<!--              <th class="uppercase text-sm p-1 md:p-3">offered by</th>-->
<!--              <th class="uppercase text-sm p-1 md:p-3">city</th>-->
<!--              <th class="uppercase text-sm p-1 md:p-3">added on</th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <template v-if="type === 'all' && state === 'all' && city === 'all' && date === 'all'">-->
<!--              <tr v-for="career in careers" class="align-top	">-->
<!--                <td class="p-1 md:p-3">-->
<!--                  <NuxtLink :to="'/employment/title/'+career.id" class="text-darkRed underline hover:text-grayLight font-semibold"><span>{{ career.title }}</span></NuxtLink>-->
<!--                </td>-->
<!--                <td class="text-veryDarkGray text-tiny p-1 md:p-3">{{career.company}}</td>-->
<!--                <td class="text-veryDarkGray text-tiny p-1 md:p-3">{{career.city}}</td>-->
<!--                <td class="text-veryDarkGray text-tiny p-1 md:p-3">{{career.created_at}}</td>-->
<!--              </tr>-->
<!--            </template>-->
<!--            <template v-if="filtered_careers.length !== 0">-->
<!--              <tr v-for="career in filtered_careers">-->
<!--                <td>-->
<!--                  <NuxtLink :to="'/employment/title/'+career.id" class="text-darkRed underline hover:text-grayLight font-semibold"><span>{{ career.title }}</span></NuxtLink>-->
<!--                </td>-->
<!--                <td class="text-veryDarkGray text-tiny">{{career.company}}</td>-->
<!--                <td class="text-veryDarkGray text-tiny">{{career.city}}</td>-->
<!--                <td class="text-veryDarkGray text-tiny">{{career.created_at}}</td>-->
<!--              </tr>-->
<!--            </template>-->
<!--            </tbody>-->
<!--          </table>-->
        </div>
      </div>
    </div>
    <div v-else>
      <LoadersSpinner />
    </div>
  </div>
</template>

<script setup>
import { http } from "~/utils/http";
import { computed, ref } from "vue";
import {useSiteURL} from "~/composables/state";

const careers = ref([]);
const types = ref([]);
const type = ref('');
const states = ref([]);
const state = ref('');
const cities = ref([]);
const city = ref('');
const dates = ref([]);
const date = ref('');
const ready = ref(false);
const siteURL = useSiteURL();


const filtered_careers = computed(
    () => careers.value.filter((item)=>
        ((item.type === type.value && type.value !== 'all') && state.value === 'all' && city.value === 'all' && date.value === 'all')
        || ((item.state === state.value && state.value !== 'all') && type.value === 'all' && city.value === 'all' && date.value === 'all')
        || ((item.city.includes(city.value) && city.value !== 'all') && type.value === 'all' && state.value === 'all' && date.value === 'all')
        || ((item.created_at_full.includes(date.value) && date.value !== 'all') && type.value === 'all' && state.value === 'all' && city.value === 'all')
        || ((item.type === type.value && type.value !== 'all') && (item.state === state.value && state.value !== 'all') && city.value === 'all' && date.value === 'all')
        || ((item.type === type.value && type.value !== 'all') && (item.city.includes(city.value) && city.value !== 'all') && state.value === 'all' && date.value === 'all')
        || ((item.type === type.value && type.value !== 'all') && (item.created_at_full.includes(date.value) && date.value !== 'all') && state.value === 'all' && city.value === 'all')
        || ((item.state === state.value && state.value !== 'all') && (item.city.includes(city.value) && city.value !== 'all') && type.value === 'all' && date.value === 'all')
        || ((item.state === state.value && state.value !== 'all') && (item.created_at_full.includes(date.value) && date.value !== 'all') && type.value === 'all' && city.value === 'all')
        || ((item.city.includes(city.value) && city.value !== 'all') && (item.created_at_full.includes(date.value) && date.value !== 'all') && type.value === 'all' && state.value === 'all')
        || ((item.type === type.value && type.value !== 'all') && (item.state === state.value && state.value !== 'all') && (item.city.includes(city.value) && city.value !== 'all') && date.value === 'all')
        || ((item.type === type.value && type.value !== 'all') && (item.state === state.value && state.value !== 'all') && (item.created_at_full.includes(date.value) && date.value !== 'all') && city.value === 'all')
        || ((item.type === type.value && type.value !== 'all') && (item.city.includes(city.value) && city.value !== 'all') && (item.created_at_full.includes(date.value) && date.value !== 'all') && state.value === 'all')
        || ((item.state === state.value && state.value !== 'all') && (item.city.includes(city.value) && city.value !== 'all') && (item.created_at_full.includes(date.value) && date.value !== 'all') && type.value === 'all')
        || ((item.type === type.value && type.value !== 'all') && (item.state === state.value && state.value !== 'all') && (item.city.includes(city.value) && city.value !== 'all') && (item.created_at_full.includes(date.value) && date.value !== 'all'))
    )
)

const resetFilter = () => {
  type.value = 'all';
  state.value = 'all';
  city.value = 'all';
  date.value = 'all';
}

const getCareers = async () => {
  states.value = [];
  type.value = 'all';
  state.value = 'all';
  city.value = 'all';
  date.value = 'all';
  states.value.push({
    id: 'all',
    name: 'All'
  })
  cities.value = [];
  cities.value.push({
    id: 'all',
    name: 'All'
  })
  dates.value.push({
    id: 'all',
    name: 'All'
  })
  try {
    let id = 'status';
    await http.get("/api/career/" + id).then((response) => {
      response.data.forEach((career)=> {
          if (career.state === 0) {
            career.state = '';
          } else {
            career.state = career.state_province.id;
          }
          careers.value.push({
            id: career.id,
            title: career.title,
            company: career.company.name,
            image: career.company.image,
            city: career.city,
            created_at: new Intl.DateTimeFormat('default', {    timeZone: 'utc',year:'numeric', month:'short', day:'numeric'}).format(new Date(career.created_at)),
            created_at_full: career.created_at,
            type: career.career_type? career.career_type.id:'',
            state: career.state,
          });
          let i_state = states.value.map(item => item.id).indexOf(career.state_province.id);
          if (i_state < 0) {
            states.value.push({
              id: career.state_province.id,
              name: career.state_province.name
            })
          }
          let i_city = cities.value.map(item => item.name).indexOf(career.city);
          if (i_city < 0) {
            cities.value.push({
              id: career.city,
              name: career.city
            })
          }
          let i_date = dates.value.map(item => item.full_date).indexOf(career.created_at);
          if (i_date < 0) {
            dates.value.push({
              id: career.created_at,
              name: new Intl.DateTimeFormat('default', {    timeZone: 'utc',year:'numeric', month:'numeric', day:'numeric'}).format(new Date(career.created_at)),
              full_date: career.created_at
            })
          }
      })
      ready.value = true;
    });
  } catch (e) {}
};

const getCategories = async () => {
  try {
    await http
        .get("/api/career-types")
        .then((response) => {
          types.value.push({
            id: 'all',
            name: 'All',
          })
          response.data.forEach((item) => {
            if (item.category === 'category') {
              types.value.push({
                id: item.id,
                name: item.name,
              })
            }
          });
        })
  } catch (e) {
    console.log(e.response.data.error);
  }
}

// await Promise.all([getCareers(), getCategories()]);
await Promise.all([getCareers()]);
</script>
